import { Navbar } from 'react-bootstrap';
import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';

interface ThemedProps {
  theme: DefaultTheme;
}

const StyledNavbar = styled(Navbar)<ThemedProps>`
  background: ${({ theme }) => theme.colors.verticalgradients.header} !important;
  border-bottom: ${({ theme }) => theme.navbar.headerBorder || 'none'};
`;

export default StyledNavbar;
